import styled from 'styled-components'
import { useIntl } from 'react-intl'
import React from 'react'
import { Card, H8, Spacer } from 'app-v2/design-systems'
import { COLOR, SPACING } from 'app-v2/design-tokens'
//$FlowFixMe
import takeOffCard from '../assets/tpk-2024-take-off-card.webp'
import { StyledText } from './styles'
import { Info as InfoIcon } from 'app/assets/icons'
import { breakpoints } from 'app/assets/styles'

export const InfoKeepCard = () => {
    const intl = useIntl()
    return (
        <StyledCard>
            <StyledDescriptionContainer>
                <StyledTitleContainer>
                    <InfoIcon size={24} color={COLOR.PRIMARY} />

                    <H8>
                        {intl.formatMessage({
                            id: 'tupreferesking.duel.keep-card.title'
                        })}
                    </H8>
                </StyledTitleContainer>

                <Spacer size={SPACING.S} />

                <StyledTextLeftAlign>
                    {intl.formatMessage({
                        id: 'tupreferesking.duel.keep-card.description'
                    })}
                </StyledTextLeftAlign>
            </StyledDescriptionContainer>

            <StyledImage src={takeOffCard} alt="keep-card" />
        </StyledCard>
    )
}

const StyledTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${SPACING.S};
    align-items: center;
`

const StyledTextLeftAlign = styled(StyledText)`
    justify-content: start;
    text-align: left;
`

const StyledDescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const StyledCard = styled(Card)`
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    gap: ${SPACING.L};
    padding: ${SPACING.L};
    padding-bottom: 0;

    @media (max-width: ${breakpoints.small}px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`

const StyledInfo = styled.div`
    background: rgba(80, 35, 20, 0.06);
    padding: 16px;
    display: flex;
    border-radius: 12px;
    gap: 8px;
    justify-content: center;
    flex-direction: row;
    align-items: center;
`

const StyledImage = styled.img`
    max-width: 226px;
`
